import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type ImporterEvents =
  | 'OPEN'
  | 'CANCEL'
  | 'HELP'
  | 'DATA_TYPE_SELECT'
  | 'DATA_TYPE_PRESELECT'
  | 'TEMPLATE_UPLOAD'
  | 'TEMPLATE_REMOVE'
  | 'TEMPLATE_SELECT'
  | 'TEMPLATE_DOWNLOAD'
  | 'CONTINUE';

export const importerEvents: Record<ImporterEvents, MixpanelEvent> = {
  OPEN: {
    eventDescription: 'Importer Opened',
    eventKey: 'importer-opened',
    eventSource: EventSource.VIEW_RENDER,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  CANCEL: {
    eventDescription: 'Importer Cancel Clicked',
    eventKey: 'importer-cancel-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CANCEL_BUTTON
  },
  HELP: {
    eventDescription: 'Importer Help Clicked',
    eventKey: 'importer-help-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  },
  DATA_TYPE_SELECT: {
    eventDescription: 'Importer Data Type Selected',
    eventKey: 'importer-data-type-selected',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MUI_SELECT
  },
  DATA_TYPE_PRESELECT: {
    eventDescription: 'Importer Data Type Preselected',
    eventKey: 'importer-data-type-preselected',
    eventSource: EventSource.VIEW_RENDER,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.MUI_SELECT
  },
  TEMPLATE_UPLOAD: {
    eventDescription: 'Importer Template Uploaded',
    eventKey: 'importer-template-uploaded',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  },
  TEMPLATE_REMOVE: {
    eventDescription: 'Importer Template Removed',
    eventKey: 'importer-template-removed',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  },
  TEMPLATE_SELECT: {
    eventDescription: 'Importer Template Selected',
    eventKey: 'importer-template-selected',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MUI_SELECT
  },
  TEMPLATE_DOWNLOAD: {
    eventDescription: 'Importer Template Downloaded',
    eventKey: 'importer-template-downloaded',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  CONTINUE: {
    eventDescription: 'Importer Continue Clicked',
    eventKey: 'importer-continue-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  }
} as const;
